export const DEFAULT_IMAGE = 'https://resource.platform.dabeeo.co.kr/assets/tenants/tenant_base.png';

export const MOBILE_SHARE_DEFAULT = 'https://resource.platform.dabeeo.co.kr/assets/mobile/mobile-share-default.png';
export const MOBILE_PARKING_DEFAULT = 'https://resource.platform.dabeeo.co.kr/assets/mobile/mobile-parking-default.png';
